import React, {useState, useEffect, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Spinner, 
  Input, 
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Slider,
  Checkbox,
  IconButton,
  Typography
} from '@material-tailwind/react'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
import { getOp20Trade } from '../../../util/op20-api';
import { debounce } from 'lodash';
import { formatFloat, formatNumberWithCommas, convertTimestampToDate } from '../../../util/format-data';
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useSelector } from 'react-redux';


const Op20Marketplace = () => {
  const { t } = useTranslation();

  const price = useSelector(state => state.price);
  const [ticker, setTicker] = useState("");
  const [timeFilter, setTimeFilter] = useState("All");
  const [sort, setSort] = useState(3);
  const [direct, setDirect] = useState(1);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const timeFilters = ["1d", "7d", "30d", "All"]
  
  useEffect(() => {
    fetchData(ticker, page);
  }, [sort, direct, page, timeFilter]);

  const fetchData = async (ticker, page) => {
    setLoading(true);
    let direction = direct == 0 ? "asc" : "desc";
    let order = "volume";
    switch (sort) {
      case 1:
        order = "price";
        break;
      case 2:
        order = "price";
        break;
      case 3:
        order = "volume";
        break;
      case 4:
        order = "marketCap";
        break;
      case 5:
        order = "trades";
        break;
    }

    const data = await getOp20Trade(page, limit, ticker, order, direction, timeFilter);
    setDatas(data.data);
    setTotal(Math.ceil(data.total / limit));
    setLoading(false);
  }

  const debouncedSearch = useCallback(debounce(async (value) => {
    await fetchData(value, 1);
  }, 500), []); 

  const handleSearch = (e) => {
    setTicker(e.target.value);
    setPage(1);
    debouncedSearch(e.target.value);
  }

  const handleOrder = (value) => {
    setSort(value);
    setDirect(direct == 1 ? 0 : 1);
  }

  const handleTimeFilter = (filter) => {
    setTimeFilter(filter);
  }

  const handleAlkanes = (data) => {
    navigate('/trade/op_return/' + data.ticker);
  }

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const doublePrev = () => {
    setPage(1);
  }

  const doubleNext = () => {
    setPage(total);
  }


  return (
    <div className="text-white mt-3 w-full md:px-7 px-2 flex flex-col items-center mb-10 min-h-[600px] gap-3">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      <div className="flex flex-row justify-between items-center w-full mt-3">
        <div className="text-white text-xl sm:text-2xl font-bold">
          {t('Top Tokens')}
        </div>
        <div className="sm:max-w-[300px] max-w-[200px] w-full">
          <Input
            type="text"
            label={t('Ticker')}
            value={ticker}
            onChange={handleSearch}
            className=""
            color="white"
          />
        </div>
      </div>
      <div className="flex flex-row justify-end w-full gap-[1px]">
        {timeFilters.map((filter, index) => (
          <div key={index} className={`${timeFilter == filter ? "bg-background2" : "bg-background1"} flex flex-row items-center justify-center text-white text-md font-bold w-[40px] h-[40px] cursor-pointer hover:bg-background2 ${index === 0 ? 'rounded-l-md' : index === timeFilters.length - 1 ? 'rounded-r-md' : ''}`} onClick={() => handleTimeFilter(filter)}>
            {filter}
          </div>
        ))}
      </div>
      <div className="w-full flex flex-col gap-2 p-2 rounded-md bg-background3 ">
        <div className="flex flex-row justify-between w-full bg-background2 rounded-md px-2 py-3">  
          <div className = "md:w-[15%] w-[70%] flex flex-row gap-1 items-center">
            <span>{t('Ticker')}</span>
          </div>
          <div className = "md:w-[15%] w-[30%] flex flex-row gap-1 items-center">
            <span>{t('Price')} (sats)</span>
            <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(1)}>
              <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 1 && direct == 1 ? 'text-primary' : 'text-white'}`} />
              <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 1 && direct == 0 ? 'text-primary' : 'text-white'}`} />
            </div>
          </div>
          {/* {
            timeFilter == "All" ?
            <></>
            :
            <div className = "md:w-[15%] md:flex hidden flex-row gap-1 items-center">
              <span>{t('Price')} {timeFilter == "All" ? '' : `% (${timeFilter})`}</span>
              <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(2)}>
                <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 2 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 2 && direct == 0 ? 'text-primary' : 'text-white'}`} />
              </div>
            </div>
          } */}
          <div className = "md:w-[15%] md:flex hidden flex-row gap-1 items-center">
            <span>{t('Volume')} {timeFilter == "All" ? '' : ` (${timeFilter})`}</span>
            <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(3)}>
              <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 3 && direct == 1 ? 'text-primary' : 'text-white'}`} />
              <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 3 && direct == 0 ? 'text-primary' : 'text-white'}`} />
            </div>
          </div>
          <div className = "md:w-[15%] md:flex hidden flex-row gap-1 items-center">
            <span>{t('Market Cap')} (BTC)</span>
            <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(4)}>
              <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 4 && direct == 1 ? 'text-primary' : 'text-white'}`} />
              <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 4 && direct == 0 ? 'text-primary' : 'text-white'}`} />
            </div>
          </div>
          <div className = "md:w-[10%] md:flex hidden flex-row gap-1 items-center">
            <span>{t('Trades')} {timeFilter == "All" ? '' : ` (${timeFilter})`}</span>
            <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(5)}>
              <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 5 && direct == 1 ? 'text-primary' : 'text-white'}`} />
              <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 5 && direct == 0 ? 'text-primary' : 'text-white'}`} />
            </div>
          </div>
          <div className = "md:w-[10%] md:flex hidden flex-row gap-1 items-center">
            <span>{t('Supply')}</span> 
          </div>
          <div className = "md:w-[8%] md:flex hidden flex-row gap-1 items-center">
            <span>{t('Time')}</span>
          </div>
        </div>
        {
          datas.map((data) => (
            <div key={uuidv4()} className="flex flex-row justify-between w-full rounded-md px-2 py-4 border-b-[1px] border-background2 cursor-pointer hover:bg-background" onClick={() => handleAlkanes(data)}>  
              <div className = "md:w-[15%] w-[70%] flex flex-row gap-2 items-center">
                {
                  data.img != "" ?
                  <img src={data.img} className="w-[30px] h-[30px] rounded-md" />
                  :
                  <div className="w-[30px] h-[30px] rounded-md bg-primary flex items-center justify-center min-w-[30px]">
                    <div className="text-white font-bold break-words">{data.ticker.slice(0, 2)}</div>
                  </div>
                }
                <div className="text-primary font-bold break-words max-w-[200px]">{data.ticker}</div>
              </div>
              <div className = "md:w-[15%] w-[30%] flex flex-col gap-1 items-start justify-center">
                <span>{data.price} sats</span>
                <span className="text-gray-400 text-sm">${formatFloat((data.price * price.bitcoin / Math.pow(10, 8)), 2)}</span>
              </div>
              
              {/* {
                timeFilter == "All" ?
                <></>
                :
                <div className = "md:w-[15%] md:flex hidden flex-row gap-1 items-center">
                  <span>{data.pricePercent}</span>
                </div>
              } */}
              <div className = "md:w-[15%] md:flex hidden flex-col gap-1 items-start justify-center">
                <span>{formatFloat((data.volume / Math.pow(10, 8)), 5)} BTC</span>
                <span className="text-gray-400 text-sm">${formatFloat((data.volume * price.bitcoin / Math.pow(10, 8)), 2)}</span>
              </div>
              <div className = "md:w-[15%] md:flex hidden flex-col gap-1 items-start justify-center">
                <span>{formatFloat((data.supply * data.price / Math.pow(10, 8)), 2)} BTC</span>
                <span className="text-gray-400 text-sm">${formatFloat((data.supply * data.price * price.bitcoin / Math.pow(10, 8)), 2)}</span>
              </div>
              <div className = "md:w-[10%] md:flex hidden flex-row gap-1 items-center">
                <span>{data.trades}</span>
              </div>
              <div className = "md:w-[10%] md:flex hidden flex-row gap-1 items-center">
                <span>{formatNumberWithCommas(data.supply)}</span>
              </div>
              <div className = "md:w-[8%] md:flex hidden flex-row gap-1 items-center">
                <span>{convertTimestampToDate(data.deployTime * 1000)}</span>
              </div>
            </div>
          ))
        }
        {
          total > 1 ? 
          <div className="flex flex-row items-center justify-center gap-8 mt-5">
            <div className="flex flex-row items-center gap-2">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={doublePrev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={prev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
            <Typography color="white" className="font-normal">
              {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
              <strong className="text-primary">{total}</strong>
            </Typography>
            <div className="flex flex-row items-center gap-2">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={next}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={doubleNext}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
          </div>
          :
          <></>
        }
      </div>
    </div>
  );
};

export default Op20Marketplace;